export const DROPBOX_FILES_DOWNLOAD_REQUEST = 'DROPBOX_FILES_DOWNLOAD_REQUEST';
export const DROPBOX_FILES_DOWNLOAD_SUCCESS = 'DROPBOX_FILES_DOWNLOAD_SUCCESS';
export const DROPBOX_FILES_DOWNLOAD_FAILURE = 'DROPBOX_FILES_DOWNLOAD_FAILURE';
